import toastMsg from '../../../../../../lib/toastMsg';
import appToastMsg from '../../../../../../constants/service/toastMsg/appToastMsg';
import { useGenerateCouponMutate } from './query';

export const useGenerateCoupon = () => {
  const { mutateAsync } = useGenerateCouponMutate({
    options: {
      onSuccess: () => toastMsg.success(appToastMsg.GENERATE_COUPON_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
    },
  });

  return { generateCoupon: mutateAsync };
};
